'use strict';

(function() {

    window.MOBILE_BREAKPOINT = 1229;
    window.MOBILE_MD_BREAKPOINT = 992;
    window.MOBILE_SM_BREAKPOINT = 768;
    var isTouch = Modernizr.touchevents;

    var mainMenu = {

        isDesktop: undefined,

        init: function () {
            this.$dropdownTriggers = $('.js-dropdown-trigger');
            this.$dropdownParents = $('.js-has-dropdown');
            this.$dropdowns = $('.js-mobile-subnav');
            this.$window = $(window);
            this.$body = $('body');

            this.checkWidth();
            this.addListeners();
        },

        addListeners: function () {
            var self = this;
            this.$window.resize(function () {
                self.checkWidth();
            });
        },

        checkWidth: function () {
            if (this.$window.width() >= MOBILE_BREAKPOINT) {
                if (this.isDesktop === false || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = true;
                    this.resetMobile();
                    this.desktop();
                }
            }
            else {
                if (this.isDesktop === true || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = false;
                    this.resetDesktop();
                    this.mobile();
                }
            }
        },

        resetMobile: function () {
            this.$body.removeClass('show-mobile');
            this.$body.off('.dropdownmobile');
        },

        mobile: function () {
            var self = this;

            this.$body.on('click.dropdownmobile', '#js-mobile-menu-trigger, .js-mask, #js-mobile-menu-close', function (e) {
                e.preventDefault();

                self.toggleMenu();
            })
            .on('click.dropdownmobile', '.js-header-search', function(e) {
                e.preventDefault();

                self.toggleMenu();

                setTimeout(function() {
                    $('.js-mobile-search').find('input').focus();
                }, 200);
            })
            .on('click.dropdownmobile', '.js-dropdown-trigger', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    $li = $this.parent();

                $li.addClass('show-subnav');
            })
            .on('click.dropdownmobile', '.js-nav-item-back', function (e) {
                e.preventDefault();

                self.$dropdownParents.removeClass('show-subnav');
            });
        },

        toggleMenu: function () {
            this.$body.toggleClass('show-mobile');
        },

        resetDesktop: function () {
            this.$body.off('.desktop').off('.body');
        },

        desktop: function () {
            var self = this;

            if(isTouch) {
                this.$body.on('click.desktop', '.js-dropdown-trigger', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $this = $(this),
                        $li = $this.parent();

                    self.$body.off('.body');

                    if ($li.hasClass('show-dropdown')) {
                        $li.removeClass('show-dropdown');
                    }
                    else {
                        self.$dropdownParents.removeClass('show-dropdown');
                        $li.addClass('show-dropdown');
                        self.bodyClick();
                    }
                })
                .on('click.desktop', '.js-movile-subnav', function(e) {
                    e.stopPropagation();
                });
            }
        },

        bodyClick: function() {
            var self = this;

            this.$body.off('.body').one('click.body', function (e) {
                console.log('body click');
                self.$dropdownParents.removeClass('show-dropdown');
            });
        }

    };

    var collection = {

        isDesktop: undefined,

        init: function () {
            if($('.template-collection').length) {
                this.$collapse = $('.js-mobile-collapse-section');
                this.$window = $(window);
                this.$body = $('body');

                this.checkWidth();
                this.addListeners();
            }
        },

        addListeners: function () {
            var self = this;
            this.$window.resize(function () {
                self.checkWidth();
            });
        },

        checkWidth: function () {
            if (this.$window.width() >= MOBILE_MD_BREAKPOINT) {
                if (this.isDesktop === false || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = true;
                    this.resetMobile();
                    this.desktop();
                }
            }
            else {
                if (this.isDesktop === true || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = false;
                    this.resetDesktop();
                    this.mobile();
                }
            }
        },

        resetMobile: function () {
            this.$body.off('.collection');
        },

        mobile: function () {
            var self = this;

            this.$body.on('click.collection', '.js-collapse-header', function (e) {
                e.preventDefault();

                $(this).parents('.js-mobile-collapse-section').toggleClass('show-content');
            });
        },

        resetDesktop: function () {
            this.$body.off('.desktop').off('.body');
        },

        desktop: function () {

        }

    };

    var browseBy = {

        init: function() {
            this.$browse = $('#BrowseBy');

            if(this.$browse.length) {
                this.addListeners();
            }
        },

        addListeners: function() {
            this.$browse.on('change', function () {
                location.href = $(this).val();
            });
        }

    };

    var sortBy = {

        init: function() {
            this.$sort = $('#SortBy');

            if(this.$sort.length) {
                this.$sort.val(sortByValGlobal);

                this.addListeners();
            }
        },

        addListeners: function() {
            this.$sort.on('change', function () {
                Shopify.queryParams.sort_by = $(this).val();
                location.search = $.param(Shopify.queryParams);
            });
        }

    };

    var collapse = {

        init: function() {
            this.$headers = $('.js-collapse-header');

            if(this.$headers.length) {
                this.addListeners();
            }
        },

        addListeners: function() {
            var self = this;

            $('body').on('click', '.js-collapse-header', function() {
                $(this).parent().toggleClass('show-collapse');
            });
        }

    };

    var product = {

        isDesktop: undefined,

        sliderInit: false,

        init: function() {
            this.$img = $('.js-product-img');

            if(this.$img.length) {
                this.$thumbs = $('.js-product-thumb');
                this.$thumb = $('.js-thumb');
                this.$slider = $('.js-cycle-slideshow');
                this.$prev = $('.js-prev');
                this.$next = $('.js-next');
                this.$window = $(window);
                this.$body = $('body');
                this.addListeners();

                if(!isTouch) {
                    this.setupMagnify();
                }
            }
        },

        addListeners: function() {
            var self = this,
                sliderOpts = {};

            this.$body.on('click', '.js-product-thumb', function (e) {
                e.preventDefault();

                self.$thumbs.parent().removeClass('active');
                $(this).parent().addClass('active');
                self.$img.find('img').attr('src', this.getAttribute('href'));
                self.$img.attr('href', this.getAttribute('data-large'));

                if(!isTouch) {
                    self.$zoom.magnify('destroy');
                    self.setupMagnify();
                }
            });

            if(this.$slider.length) {
                this.checkWidth();

                this.$window.resize(function () {
                    self.checkWidth();
                });
            }

            this.$body.on('change', '#productSelect', function(){
              
                //var name = $("#productSelect option:selected").text().split(" - ")[1].replace(" USD", ""); //grab price -- LETS NOT DO IT THIS WAY
              	var name = $("#productSelect option:selected").attr('data-price');
              	var comparePriceName = $("#productSelect option:selected").attr('data-compare'); //grab price
                
              	$('#ProductPrice').html(name) //replace price
              	$('#ProductPrice').removeClass('product-price--on-sale');

                if(comparePriceName == '' || comparePriceName == null){
                	$('#ProductComparePrice').hide();
                  	$('#ProductPrice').removeClass('product-price--on-sale');
                } else {
					$('#ProductComparePrice').show();
               		$('#ProductComparePrice del').html(comparePriceName);
                  	$('#ProductPrice').addClass('product-price--on-sale');
                }

            });

            $('.tabs').each(function(){
                var $active, $content, $links = $(this).find('a');
                $active = $links.first().addClass('active');
                $content = $($active.attr('href'));
                $links.not(':first').each(function () {
                    $($(this).attr('href')).hide();
                });
                $(this).on('click', 'a', function(e){
                    // Make the old tab inactive.
                    $active.removeClass('active');
                    $content.hide();

                    // Update the variables with the new link and content
                    $active = $(this);
                    $content = $($(this).attr('href'));

                    // Make the tab active.
                    $active.addClass('active');
                    $content.show();

                    // Prevent the anchor's default click action
                    e.preventDefault();
                });
            });
        },

        setupMagnify: function() {
            this.$zoom = this.$img.find('img').magnify();
        },

        checkWidth: function () {
            if (this.$window.width() >= MOBILE_SM_BREAKPOINT) {
                if (this.isDesktop === false || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = true;
                    this.resetMobile();
                    this.desktop();
                }
            }
            else {
                if (this.isDesktop === true || typeof this.isDesktop === 'undefined') {
                    this.isDesktop = false;
                    this.resetDesktop();
                    this.mobile();
                }
            }
        },

        resetMobile: function () {

        },

        mobile: function () {

        },

        resetDesktop: function () {

        },

        desktop: function () {

        }

    };

    var readMore = {

        template: '<div class="read-more__grad"></div><button class="read-more__btn js-read-more-btn" type="button">+ Read More</button>',

        init: function () {
            this.$readMore = $('.js-read-more');

            if (this.$readMore.length) {
                this.start();
                this.addListeners();
            }
        },

        start: function () {
            var self = this;

            this.$readMore.each(function () {
                var rect = this.getBoundingClientRect();
                this.classList.add('read-more');
                this.classList.add('read-more--closed');
                if (rect.height > 200) self.setup(this);
            });
        },

        setup: function(el) {
            $(el).append(this.template);
            el.style.height = '200px';
        },

        addListeners: function () {
            var self = this;

            this.$readMore.on('click', '.js-read-more-btn', function (e) {
                var $parent = $(this).parents('.js-read-more');
                $parent.toggleClass('read-more--closed');

                if ($parent.hasClass('read-more--closed')) {
                    $parent[0].style.height = '200px';
                    this.innerText = '+ Read More';
                    $('html, body').animate({ scrollTop: $parent.offset().top - 105 });
                }
                else {
                    $parent[0].style.height = '';
                    this.innerText = '- Read Less';
                }
            });
        }

    };

    $(function() {
        mainMenu.init();
        browseBy.init();
        sortBy.init();
        collapse.init();
        product.init();
        collection.init();
        readMore.init();

        $('.flexslider').flexslider();

        var $images = $('.js-img-loader');
        if ($images.length)
            $images.imageLoad();
      
      // product contact form
      	var $productContactForm = $('#ProductContactForm');      
        $productContactForm.on('submit', function(e) {
          e.preventDefault();
          var productContactEmail = $('#ProductContactFormEmail').val();         
          if (productContactEmail.length > 0) {
            $.ajax({
              type: 'GET',
              url: 'https://hooks.zapier.com/hooks/catch/12450/o6uxw59',
              data: $.param({ email_address: productContactEmail }),
              contentType: 'application/x-www-form-urlencoded; charset=utf-8',
              success: function(res) {
                $productContactForm.hide().after('<div class="footer-contact-success">Thank you for contacting us!</div>');
              },
              failure: function(err) {
                console.log(err);
              }
            });
          }
        });
      
      // footer contact form
      	var $footerContactForm = $('#FooterContactForm');      
        $footerContactForm.on('submit', function(e) {
          e.preventDefault();
          var footerContactEmail = $('#FooterContactFormEmail').val();         
          if (footerContactEmail.length > 0) {
            $.ajax({
              type: 'GET',
              url: 'https://hooks.zapier.com/hooks/catch/12450/o6uxw59',
              data: $.param({ email_address: footerContactEmail }),
              contentType: 'application/x-www-form-urlencoded; charset=utf-8',
              success: function(res) {
                $footerContactForm.hide().after('<div class="footer-contact-success">Thank you for contacting us!</div>');
              },
              failure: function(err) {
                console.log(err);
              }
            });
          }
        });
  
      	// footer newsletter sign up form
      	var $footerNewsletterForm = $('#NewsletterForm');
        $footerNewsletterForm.on('submit', function(e) {
          e.preventDefault();
          var newsletterEmail = $('#NewsletterFormEmail').val();
          if (newsletterEmail.length > 0) {
            $.ajax({
              type: 'GET',
              url: 'https://hooks.zapier.com/hooks/catch/12450/o6uxw59',
              data: $.param({ email_address: newsletterEmail }),
              contentType: 'application/x-www-form-urlencoded; charset=utf-8',
              success: function(res) {
                $footerNewsletterForm.hide().after('<div class="newsletter-success">Thank you for signing up!</div>');
              },
              failure: function(err) {
                console.log(err);
              }
            });
          }
        });
    });

})();
